function split4(str) {
  return str.split(/(.{4})/).filter(Boolean);
}

export function mod97(str) {
  const parts = split4(str); // Handle in groups of 4 chars to avoid too large integers
  return parts.reduce((acc, part) => parseInt(`${acc}${part}`, 10) % 97);
}

export function groupIban(str) {
  return split4(str).join(' ');
}

export function sanitizeIban(str) {
  return str.replace(/\W+/g, '').toUpperCase();
}

export function formatIban(str) {
  return groupIban(sanitizeIban(str));
}

export function mapIban(str, fn) {
  return split4(sanitizeIban(str)).map(fn);
}
